import React, {useMemo} from "react";
import {DollarOutlined, PlusOutlined} from "@ant-design/icons";
import {MakePaymentSection, AmountPayable, MakePaymentButton} from "../styles/PaymentsPage.styles";
import {message, Popconfirm} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {toTurkishProperCase} from "utils/toTurkishProperCase";

const formatAmount = value => {
    return new Intl.NumberFormat("tr-TR").format(value ?? 0);
};

const normalizeIdList = value => {
    if (value == null || value === "") return [];
    return Array.isArray(value) ? value : [value];
};

/** Filtrelerdeki ZoneManagementSelect / ZoneSelect ile aynı kaynak: id listesini isimlere çevirir */
const mapIdsToNames = (ids, list) => {
    if (!ids.length) return "";
    if (!Array.isArray(list)) return ids.join(", ");
    const names = ids
        .map(id => list.find(item => item?._id?.toString() === String(id))?.name)
        .filter(Boolean);
    return names.length ? names.join(", ") : ids.join(", ");
};

export const MakePayment = ({
    amountPayable,
    onPaymentSuccess,
    zoneManagement,
    zone,
    city,
    status,
    searchText,
    zoneManagementList = {data: []},
    zoneList = {data: []},
    showPaymentButton = true,
    excelButton,
    embedded = false
}) => {
    const stores = useStore();

    const zoneManagementLabel = useMemo(
        () => mapIdsToNames(normalizeIdList(zoneManagement), zoneManagementList?.data),
        [zoneManagement, zoneManagementList]
    );

    const zoneLabel = useMemo(() => mapIdsToNames(normalizeIdList(zone), zoneList?.data), [
        zone,
        zoneList
    ]);

    const cityLabel = useMemo(() => {
        const parts = normalizeIdList(city);
        if (!parts.length) return "";
        return parts.map(p => toTurkishProperCase(String(p))).join(", ");
    }, [city]);

    const [makePaymentRequestLoading, , , , refetchMakePaymentRequest] = useFetch({
        fetchFn: () =>
            stores.courierWithdrawRequestStore.makePaymentRequest({
                zoneManagementId: zoneManagement,
                zoneId: zone,
                cityId: city,
                amount: amountPayable,
                status: status,
                searchText: searchText
            }),
        initialCall: false,
        callbackFunc: result => {
            if (result) {
                onPaymentSuccess();
            } else {
                message.error("Ödeme yapılırken bir hata oluştu");
            }
        }
    });

    return (
        <MakePaymentSection embedded={embedded}>
            <AmountPayable>
                <DollarOutlined className="amount-icon" />
                <span>Ödenecek Tutar {formatAmount(amountPayable)} TL</span>
            </AmountPayable>
            {excelButton}
            {showPaymentButton && (
                <Popconfirm
                    title={`${zoneManagementLabel ? `${zoneManagementLabel}'ne` : ""} ${
                        zoneLabel && zoneManagementLabel ? "bağlı" : ""
                    }   ${zoneLabel ? `${zoneLabel} bölge` : ""} ${
                        zoneLabel && cityLabel ? `içindeki` : ""
                    } ${cityLabel ? `${cityLabel} ili için` : ""} ${formatAmount(
                        amountPayable
                    )} TL tutarında ödeme yapılacaktır. Onaylıyor musunuz?`}
                    onConfirm={() => refetchMakePaymentRequest()}
                    okText="Onayla"
                    cancelText="İptal"
                >
                    <MakePaymentButton type="button" disabled={makePaymentRequestLoading}>
                        <PlusOutlined />
                        Ödeme Yap
                    </MakePaymentButton>
                </Popconfirm>
            )}
        </MakePaymentSection>
    );
};
